import { Injectable, inject } from '@angular/core';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SearchMainService } from './search.main.service';

@Injectable({
  providedIn: 'root'
})
export class SearchTermResolver  {
  private readonly searchService = inject(SearchMainService);

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    const term = route.params['searchTerm'] || '';

    this.searchService.keywords = term.trim().replace(/-/g, ' ');
    this.searchService.querySearch.next(term);
    return term;
  }
}
